(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-byb-root]');
    if (!section) return;

    var STORAGE_KEY = 'ds-byb-state-v5';
    var MAX_STEP = 5; // step 5 (Customize) only exists when bonus add-ons are available

    // Discount tiers (percent), wired to your Shopify automatic discounts:
    //   6+ activities → DISC6 % off,  10+ activities → DISC10 % off.
    // Full bundle (all of an age's recommended toys) → dedicated fixed-price product.
    var DISC6 = parseInt(section.getAttribute('data-discount-6-pct') || '10', 10);
    var DISC10 = parseInt(section.getAttribute('data-discount-10-pct') || '15', 10);
    // Discount CODES the page auto-applies at checkout (so the discount is guaranteed
    // to show, independent of Shopify automatic-discount evaluation).
    var CODE6 = (section.getAttribute('data-discount-6-code') || '').trim();
    var CODE10 = (section.getAttribute('data-discount-10-code') || '').trim();

    // Recommended toys per age: { "1":[{id,pid,handle,title,image,price}], "2":[...], "3":[...] }
    var DATA = (function () {
      try { return JSON.parse(section.getAttribute('data-rec-toys') || '{}'); }
      catch (e) { return {}; }
    })();
    var SETS = DATA.sets || {};
    var BONUS = DATA.bonus || [];
    // Complete, tagged set for an (age, size) tier — e.g. SETS["1"]["6"] = the 6-toy set.
    function sizeSet(age, size) { return (age && SETS[age] && SETS[age][size]) ? SETS[age][size] : []; }
    function fullCount(age) { return sizeSet(age, 'full').length; } // full bundle size for this age

    function bagVariantId(design) {
      if (design === 'vehicles') return section.getAttribute('data-bag-vehicles-variant') || null;
      if (design === 'unicorns') return section.getAttribute('data-bag-unicorns-variant') || null;
      return null;
    }
    function bagImageUrl(design) {
      if (design === 'vehicles') return section.getAttribute('data-bag-vehicles-image') || '';
      if (design === 'unicorns') return section.getAttribute('data-bag-unicorns-image') || '';
      return '';
    }
    function bagPriceCents() {
      return parseInt(section.getAttribute('data-bag-price-cents') || '0', 10);
    }
    function fullBundlePriceCents(withBag) {
      return parseInt(section.getAttribute(withBag ? 'data-full-bundle-price-cents' : 'data-full-bundle-nobag-price-cents') || '0', 10);
    }
    function getBundleVariantMap() {
      try { return JSON.parse(section.getAttribute('data-bundle-variants') || '{}'); }
      catch (e) { return {}; }
    }

    var state = loadState() || {
      step: 1,
      age: null,       // '1' | '2' | '3'
      bag: null,       // 'vehicles' | 'unicorns' | 'none'
      size: null,      // '3' | '6' | '10' | 'full'
      customize: null, // 'yes' | 'no' — opted into bonus add-ons (step 5)
      extras: []       // bonus product ids added on top of the locked core
    };
    if (!Array.isArray(state.extras)) state.extras = [];

    function loadState() {
      try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
    }
    function saveState() {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }

    // ===== Selection model =====
    // The locked core = the complete tagged set for the chosen (age, size).
    function coreToys() { return (state.age && state.size) ? sizeSet(state.age, state.size) : []; }
    // Bonus add-ons: toggled off by default in theme settings; offered on the 3/6/10 sets only.
    function bonusEnabled() { return section.getAttribute('data-bonus-enabled') === 'true'; }
    function bonusAvailable() { return bonusEnabled() && state.size && state.size !== 'full' && BONUS.length > 0; }
    // The Customize step (5) only exists when there are bonus add-ons to offer.
    function hasCustomizeStep() { return bonusAvailable(); }
    function lastStep() { return hasCustomizeStep() ? 5 : 4; }
    function optedIntoBonus() { return state.customize === 'yes'; }
    function bonusPool() {
      var coreIds = {};
      coreToys().forEach(function (t) { coreIds[t.pid] = true; });
      return BONUS.filter(function (t) { return !coreIds[t.pid]; });
    }
    function selectedBonus() {
      if (!bonusAvailable() || !optedIntoBonus()) return [];
      return bonusPool().filter(function (t) { return state.extras.indexOf(t.pid) !== -1; });
    }
    function selectedToys() { return coreToys().concat(selectedBonus()); }
    function selectedCount() { return selectedToys().length; }
    function hasBag() { return state.bag && state.bag !== 'none'; }
    function isFullSelected() { return state.size === 'full'; }

    // ===== Labels used for cart attributes / line-item properties =====
    var SIZE_TAGS = { '3': '3toys', '6': '6toys', '10': '10toys', 'full': 'full-set' };
    function setTag() { return (state.age && state.size) ? (state.age + 'yo-' + (SIZE_TAGS[state.size] || state.size)) : ''; }
    function ageLabel() { return state.age ? (state.age + (state.age === '1' ? ' year old' : ' years old')) : ''; }
    function bagLabel() { return hasBag() ? (state.bag === 'vehicles' ? 'Vehicles' : 'Unicorns') : 'None'; }
    function tripName() {
      var input = section.querySelector('[data-byb-size][value="' + state.size + '"]');
      var card = input ? input.closest('.byb__choice') : null;
      var el = card ? card.querySelector('.byb__tier-card__trip') : null;
      return (el && el.textContent.trim()) || 'Build Your Bundle';
    }
    // Human-readable bundle type, e.g. "Long Weekend · 6 activities" (the set size).
    function tripLabel() {
      if (!state.size) return '';
      return tripName() + ' · ' + coreToys().length + ' activities';
    }

    // ===== Pricing =====
    function sumPrices(toys) {
      return toys.reduce(function (s, t) { return s + (parseInt(t.price, 10) || 0); }, 0);
    }
    function toySubtotalCents() { return sumPrices(selectedToys()); }
    function discountPct() {
      var c = selectedCount();
      if (c >= 10) return DISC10;
      if (c >= 6) return DISC6;
      return 0;
    }
    function subtotalCents() {
      return toySubtotalCents() + (hasBag() ? bagPriceCents() : 0);
    }
    function totalCents() {
      if (isFullSelected()) return fullBundlePriceCents(hasBag());
      var discounted = Math.round(toySubtotalCents() * (100 - discountPct()) / 100);
      return discounted + (hasBag() ? bagPriceCents() : 0);
    }
    function discountCents() { return Math.max(0, subtotalCents() - totalCents()); }

    function fmtCents(c) { return '$' + (c / 100).toFixed(2); }
    function humanize(s) { return (s || '').replace(/-/g, ' '); }
    function escapeHTML(s) {
      return (s || '').replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
      });
    }

    function renderProgress() {
      section.querySelectorAll('[data-step-pip]').forEach(function (pip) {
        var n = parseInt(pip.getAttribute('data-step-pip'), 10);
        pip.classList.toggle('is-active', n === state.step);
        pip.classList.toggle('is-done', n < state.step);
      });
    }

    function showStep(n) {
      n = Math.min(n, lastStep()); // never land on Customize when it doesn't apply
      state.step = n;
      section.querySelectorAll('[data-step]').forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.getAttribute('data-step'), 10) === n);
      });
      if (n === 3) renderSetup();
      if (n === 4 || n === 5) renderActivities();
      renderProgress();
      renderNav();
      renderSidebar();
      saveState();
    }

    function renderNav() {
      var back = section.querySelector('[data-byb-back]');
      var next = section.querySelector('[data-byb-next]');
      var checkout = section.querySelector('[data-byb-checkout]');
      back.disabled = state.step <= 1;

      // The 5th progress pip only shows when the Customize step applies.
      var pip5 = section.querySelector('[data-step-pip="5"]');
      if (pip5) pip5.style.display = hasCustomizeStep() ? '' : 'none';

      if (state.step >= lastStep()) {
        next.hidden = true;
        checkout.hidden = false;
      } else {
        next.hidden = false;
        checkout.hidden = true;
      }
      next.disabled = !canAdvance();
    }

    function canAdvance() {
      switch (state.step) {
        case 1: return !!state.age;
        case 2: return !!state.bag;
        case 3: return !!state.size;
        default: return true;
      }
    }

    // ===== Step 3 — travel setup (size / trip) cards =====
    function renderSetup() {
      var needAge = section.querySelector('[data-byb-size-need-age]');
      if (needAge) needAge.hidden = !!state.age;

      section.querySelectorAll('[data-byb-size]').forEach(function (input) {
        var label = input.closest('.byb__choice');
        var val = input.value;
        var countEl = label.querySelector('[data-size-count]');
        var priceEl = label.querySelector('[data-size-price]');
        var discEl = label.querySelector('[data-size-discount]');

        if (!state.age) {
          input.disabled = true;
          label.classList.add('is-unavailable');
          if (priceEl) priceEl.textContent = '—';
          return;
        }

        var set = sizeSet(state.age, val);
        var n = set.length;
        var avail = n > 0;
        input.disabled = !avail;
        label.classList.toggle('is-unavailable', !avail);

        if (val === 'full') {
          if (countEl) countEl.textContent = avail ? ('Full bundle · ' + n + ' activities') : 'Full bundle';
          if (!avail) { if (priceEl) priceEl.textContent = '—'; if (discEl) discEl.hidden = true; return; }
          var orig = sumPrices(set) + (hasBag() ? bagPriceCents() : 0);
          var fullPrice = fullBundlePriceCents(hasBag());
          if (priceEl) priceEl.innerHTML = (orig > fullPrice ? '<span class="byb__price-strike">' + fmtCents(orig) + '</span> ' : '') + fmtCents(fullPrice);
          if (discEl) discEl.hidden = false; // keeps the "Best value" label from the markup
          return;
        }

        if (countEl) countEl.textContent = n + ' activities';
        if (!avail) {
          if (priceEl) priceEl.textContent = '—';
          if (discEl) discEl.hidden = true;
          return;
        }
        var toys = sumPrices(set);
        var pct = (n >= 10) ? DISC10 : (n >= 6 ? DISC6 : 0);
        if (pct > 0) {
          if (priceEl) priceEl.innerHTML = '<span class="byb__price-strike">' + fmtCents(toys) + '</span> ' + fmtCents(Math.round(toys * (100 - pct) / 100));
          if (discEl) { discEl.hidden = false; discEl.textContent = 'Save ' + pct + '%'; }
        } else {
          if (priceEl) priceEl.textContent = fmtCents(toys);
          if (discEl) discEl.hidden = true;
        }
      });

      // If the chosen size is no longer available for this age, drop it.
      if (state.size) {
        var cur = section.querySelector('[data-byb-size][value="' + state.size + '"]');
        if (cur && cur.disabled) { state.size = null; cur.checked = false; }
      }
    }

    // ===== Step 4 — recommended activities (auto-filled, core locked) =====
    function activityCardHTML(t, isCore, checked) {
      var cls = 'byb__toy' + (isCore ? ' byb__toy--locked' : '');
      var badge = isCore
        ? '<span class="byb__toy-card__included">Included</span>'
        : (checked ? '' : '<span class="byb__toy-card__add">+ Add</span>');
      return '<label class="' + cls + '">' +
        '<input type="checkbox" data-byb-activity data-pid="' + escapeHTML(t.pid) + '" value="' + escapeHTML(String(t.id)) + '"' +
          (checked ? ' checked' : '') + (isCore ? ' disabled' : '') + '>' +
        '<span class="byb__toy-card">' +
          '<span class="byb__toy-card__media">' +
            (t.image ? '<img src="' + escapeHTML(t.image) + '" alt="' + escapeHTML(t.title) + '" loading="lazy">' : '') +
            badge +
            '<span class="byb__toy-card__check" aria-hidden="true">✓</span>' +
          '</span>' +
          '<span class="byb__toy-card__body">' +
            '<span class="byb__toy-card__title">' + escapeHTML(t.title) + '</span>' +
            '<span class="byb__toy-card__price">' + fmtCents(t.price) + '</span>' +
          '</span>' +
        '</span>' +
      '</label>';
    }

    function renderActivities() {
      var grid = section.querySelector('[data-byb-activities]');
      var empty = section.querySelector('[data-byb-activities-empty]');
      var bonusWrap = section.querySelector('[data-byb-bonus-wrap]');
      var bonusGrid = section.querySelector('[data-byb-bonus]');
      if (!grid) return;

      var core = coreToys();
      if (!state.age || !state.size || core.length === 0) {
        grid.innerHTML = '';
        if (bonusGrid) bonusGrid.innerHTML = '';
        if (bonusWrap) bonusWrap.hidden = true;
        if (empty) empty.hidden = !(state.age && state.size); // only complain once a set is chosen
        renderTotals();
        return;
      }
      if (empty) empty.hidden = true;

      // Locked core — every item is "Included" and cannot be removed.
      grid.innerHTML = core.map(function (t) { return activityCardHTML(t, true, true); }).join('');

      // Bonus add-ons live on the Customize step (5), revealed only after opt-in.
      var showBonus = bonusAvailable() && optedIntoBonus();
      if (showBonus && bonusGrid) {
        bonusGrid.innerHTML = bonusPool().map(function (t) {
          return activityCardHTML(t, false, state.extras.indexOf(t.pid) !== -1);
        }).join('');
      } else if (bonusGrid) {
        bonusGrid.innerHTML = '';
      }
      if (bonusWrap) bonusWrap.hidden = !showBonus || bonusPool().length === 0;

      renderTotals();
    }

    // Totals + banner appear on both finalize steps (4 and 5) — update every copy.
    function setAll(sel, text) {
      section.querySelectorAll(sel).forEach(function (el) { el.textContent = text; });
    }
    function renderTotals() {
      var disc = discountCents();
      setAll('[data-review-subtotal]', fmtCents(subtotalCents()));
      setAll('[data-review-total]', fmtCents(totalCents()));
      setAll('[data-review-discount]', '-' + fmtCents(disc));
      setAll('[data-review-discount-label]', isFullSelected() ? 'Full Bundle deal' : ('Bundle discount (' + discountPct() + '% off)'));
      section.querySelectorAll('[data-review-discount-row]').forEach(function (row) { row.hidden = disc <= 0; });
      renderDiscountBanner();
    }

    function renderDiscountBanner() {
      var banners = section.querySelectorAll('[data-byb-discount-banner]');
      if (!banners.length) return;
      var html = '', active = false, show = false;
      if (selectedCount() > 0) {
        if (isFullSelected()) {
          html = '🎉 Full Bundle unlocked — <strong>' + fmtCents(totalCents()) + '</strong>' + (hasBag() ? ' with backpack.' : ' (no backpack).');
          active = true; show = true;
        } else if (discountPct() > 0) {
          html = "You're saving <strong>" + discountPct() + '%</strong> on this bundle.';
          show = true;
        }
      }
      banners.forEach(function (b) {
        b.innerHTML = html;
        b.classList.toggle('byb__discount-banner--active', active);
        b.hidden = !show;
      });
    }

    function renderSidebar() {
      var list = section.querySelector('[data-byb-sidebar-list]');
      var totalEl = section.querySelector('[data-byb-running-total]');
      if (!list) return;

      // Selection summary — tells the shopper exactly what they've chosen.
      var summary = section.querySelector('[data-byb-sidebar-summary]');
      if (summary) {
        var meta = [];
        if (state.age) meta.push(['Age', ageLabel()]);
        if (state.bag) meta.push(['Backpack', bagLabel()]);
        if (state.size) meta.push(['Trip', tripLabel()]);
        if (meta.length) {
          summary.innerHTML = meta.map(function (m) {
            return '<div class="byb__sidebar-meta"><dt>' + m[0] + '</dt><dd>' + escapeHTML(m[1]) + '</dd></div>';
          }).join('');
          summary.hidden = false;
        } else {
          summary.innerHTML = '';
          summary.hidden = true;
        }
      }

      var toys = selectedToys();
      if (toys.length === 0 && !state.bag) {
        list.innerHTML = '<li class="byb__sidebar-empty">Start picking to see your bundle take shape.</li>';
      } else {
        var rows = toys.map(function (t) {
          return '<li class="byb__sidebar-item"><span class="byb__sidebar-item__title">' + escapeHTML(t.title) + '</span><span class="byb__sidebar-item__price">' + fmtCents(t.price) + '</span></li>';
        });
        if (hasBag()) {
          rows.push('<li class="byb__sidebar-item"><span class="byb__sidebar-item__title">Backpack (' + escapeHTML(humanize(state.bag)) + ')</span><span class="byb__sidebar-item__price">' + fmtCents(bagPriceCents()) + '</span></li>');
        }
        list.innerHTML = rows.join('');
      }

      var sub = subtotalCents();
      var tot = totalCents();
      if (totalEl) {
        if (tot < sub && sub > 0) {
          totalEl.innerHTML = '<span class="byb__price-strike">' + fmtCents(sub) + '</span> ' + fmtCents(tot);
        } else {
          totalEl.textContent = fmtCents(tot);
        }
      }
    }

    // Which discount code to auto-apply for the current selection (quantity-based,
    // matching the displayed tiers). Empty = no code (3-toy set or Full Bundle).
    function cartDiscountCode() {
      var pct = discountPct();
      if (pct >= DISC10) return CODE10;
      if (pct >= DISC6) return CODE6;
      return '';
    }

    function postCart(items, attributes, discountCode, fail) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { fail((res.body && res.body.description) || 'Could not add bundle to cart.'); return null; }
        // Stamp the order so fulfillment sees exactly which set to pack.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(function (r) {
        if (!r) return; // add failed above
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
        // Auto-apply the discount code via Shopify's discount URL (no typing needed),
        // then land on the cart — the code carries through to checkout.
        if (discountCode) {
          window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { fail('Network error adding to cart. Please try again.'); });
    }

    function addBundleToCart() {
      var btn = section.querySelector('[data-byb-checkout]');
      var originalText = btn.textContent;
      var fail = function (msg) { alert(msg); btn.disabled = false; btn.textContent = originalText; };

      var core = coreToys();
      if (core.length === 0) { fail('Pick an age and a trip to build your bundle.'); return; }

      btn.disabled = true;
      btn.textContent = 'Adding to cart…';
      var bag = hasBag();
      var trip = tripLabel(); // e.g. "Long Weekend · 6 activities"
      var tag = setTag();

      // Order-level attributes — show on the order and can drive Flow order tags.
      var attrs = {
        'Build Your Bundle': 'Yes',
        'Bundle Set': tag,            // e.g. 2yo-6toys
        'Bundle Age': ageLabel(),     // e.g. 2 years old
        'Bundle Trip': trip,          // e.g. Long Weekend · 6 activities
        'Bundle Backpack': bagLabel() // Vehicles / Unicorns / None
      };

      // Full bundle → single dedicated fixed-price product ($199 / $165).
      if (isFullSelected()) {
        var variantTitle = bag ? 'Full Bundle + Backpack' : 'Full Bundle';
        var variantId = getBundleVariantMap()[variantTitle];
        if (!variantId) {
          fail('Full Bundle product not configured. In the theme editor, pick a "Full Bundle product" in the section settings.');
          return;
        }
        // Keep the cart line tidy: friendly summary visible, full contents kept on
        // the order via a single hidden (_) property for fulfillment.
        var props = {
          'Trip': trip,
          'Age': ageLabel(),
          'Backpack': bagLabel(),
          '_Set': tag,
          '_Activities': core.map(function (t) { return t.title; }).join(', ')
        };
        postCart([{ id: parseInt(variantId, 10), quantity: 1, properties: props }], attrs, '', fail);
        return;
      }

      // 3 / 6 / 10 sets → individual line items; Shopify automatic discounts apply.
      var items = core.map(function (t) {
        return {
          id: parseInt(t.id, 10),
          quantity: 1,
          properties: { 'Trip': trip, '_Set': tag }
        };
      });
      selectedBonus().forEach(function (t) {
        items.push({
          id: parseInt(t.id, 10),
          quantity: 1,
          properties: { 'Trip': trip, 'Add-on': 'Bonus', '_Set': tag }
        });
      });
      if (bag) {
        var bagVar = bagVariantId(state.bag);
        if (bagVar) {
          items.push({
            id: parseInt(bagVar, 10),
            quantity: 1,
            properties: { 'Trip': trip, 'Design': bagLabel(), '_Set': tag }
          });
        }
      }
      postCart(items, attrs, cartDiscountCode(), fail);
    }

    // ===== Event listeners =====
    section.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-byb-age]')) {
        if (state.age !== t.value) { state.age = t.value; state.extras = []; }
        renderSetup();
      } else if (t.matches('[data-byb-bag]')) {
        state.bag = t.value;
        renderSetup(); // bag affects the Full Bundle price shown on the size cards
      } else if (t.matches('[data-byb-size]')) {
        state.size = t.value;
        state.extras = [];     // new core set
        state.customize = null; // re-ask the bonus opt-in for the new set
        section.querySelectorAll('[data-byb-customize]').forEach(function (i) { i.checked = false; });
        renderActivities();
      } else if (t.matches('[data-byb-customize]')) {
        state.customize = t.value;
        if (state.customize !== 'yes') state.extras = []; // dropped opt-in → clear add-ons
        renderActivities();
      } else if (t.matches('[data-byb-activity]')) {
        var pid = t.getAttribute('data-pid');
        if (t.checked) {
          if (state.extras.indexOf(pid) === -1) state.extras.push(pid);
        } else {
          state.extras = state.extras.filter(function (x) { return x !== pid; });
        }
        renderActivities(); // refresh badges
      }
      renderSidebar();
      renderNav();
      saveState();
    });

    function scrollToBuilderTop() {
      var anchor = section.querySelector('[data-byb-builder-anchor]');
      if (anchor && anchor.scrollIntoView) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    section.querySelector('[data-byb-next]').addEventListener('click', function () {
      if (!canAdvance()) return;
      showStep(Math.min(state.step + 1, lastStep()));
      scrollToBuilderTop();
    });
    section.querySelector('[data-byb-back]').addEventListener('click', function () {
      showStep(Math.max(state.step - 1, 1));
      scrollToBuilderTop();
    });
    section.querySelector('[data-byb-checkout]').addEventListener('click', function () {
      addBundleToCart();
    });

    // Gallery (swipeable hero with thumbnails, infinite-loop)
    (function initGallery() {
      var track = section.querySelector('[data-byb-gallery-track]');
      if (!track) return;
      var realSlides = Array.prototype.slice.call(track.querySelectorAll('.byb__gallery__slide'));
      var thumbs = section.querySelectorAll('[data-byb-gallery-dot]');
      var prevBtn = section.querySelector('[data-byb-gallery-prev]');
      var nextBtn = section.querySelector('[data-byb-gallery-next]');

      var realCount = realSlides.length;
      if (realCount < 2) return; // nothing to loop

      // Clone first slide at end, last slide at beginning for infinite-feel
      var firstClone = realSlides[0].cloneNode(true);
      var lastClone = realSlides[realCount - 1].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, track.firstChild);

      var allSlides = Array.prototype.slice.call(track.querySelectorAll('.byb__gallery__slide'));
      // After cloning: index 0 = lastClone, index 1..realCount = real, index realCount+1 = firstClone

      function slideWidth() { return allSlides[0].clientWidth || track.clientWidth; }

      function setScrollInstant(left) {
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        // force reflow then restore (browsers respect smooth only for scrollTo with behavior)
        track.style.scrollBehavior = prev;
      }

      // Start on the first REAL slide (index 1 after cloning)
      function jumpToRealStart() {
        setScrollInstant(allSlides[1].offsetLeft);
      }
      // Run on next frame to ensure layout is ready
      requestAnimationFrame(jumpToRealStart);
      window.addEventListener('load', jumpToRealStart, { once: true });

      function currentDomIndex() {
        return Math.round(track.scrollLeft / slideWidth());
      }
      function currentRealIndex() {
        var i = currentDomIndex();
        if (i <= 0) return realCount - 1; // on leading clone (which shows last real)
        if (i >= allSlides.length - 1) return 0; // on trailing clone (which shows first real)
        return i - 1;
      }

      function go(realIdx) {
        realIdx = ((realIdx % realCount) + realCount) % realCount;
        var domIdx = realIdx + 1;
        track.scrollTo({ left: allSlides[domIdx].offsetLeft, behavior: 'smooth' });
      }
      function updateActiveThumb() {
        var i = currentRealIndex();
        thumbs.forEach(function (t, idx) {
          t.classList.toggle('is-active', idx === i);
        });
      }

      // When user lands on a clone slide, jump (no animation) to the matching real slide
      var snapTimer = null;
      function maybeSnap() {
        var i = currentDomIndex();
        if (i <= 0) {
          // On leading clone — jump to real last slide
          setScrollInstant(allSlides[realCount].offsetLeft);
        } else if (i >= allSlides.length - 1) {
          // On trailing clone — jump to real first slide
          setScrollInstant(allSlides[1].offsetLeft);
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(currentRealIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(currentRealIndex() + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          go(parseInt(t.getAttribute('data-byb-gallery-dot'), 10));
        });
      });

      track.addEventListener('scroll', function () {
        if (track._tick) return;
        track._tick = requestAnimationFrame(function () {
          track._tick = null;
          updateActiveThumb();
        });
        // Snap after scroll settles
        clearTimeout(snapTimer);
        snapTimer = setTimeout(maybeSnap, 150);
      });
    })();

    // Mobile sidebar toggle
    var sidebar = section.querySelector('[data-byb-sidebar]');
    var sidebarToggle = section.querySelector('[data-byb-sidebar-toggle]');
    if (sidebar && sidebarToggle) {
      sidebarToggle.addEventListener('click', function () {
        if (window.innerWidth < 900) {
          var isOpen = sidebar.classList.toggle('is-open');
          sidebarToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      });
    }

    // Restore visual state from saved progress.
    function rehydrate() {
      if (state.age) {
        var ageInput = section.querySelector('[data-byb-age][value="' + state.age + '"]');
        if (ageInput) ageInput.checked = true;
      }
      if (state.bag) {
        var bagInput = section.querySelector('[data-byb-bag][value="' + state.bag + '"]');
        if (bagInput) bagInput.checked = true;
      }
      renderSetup(); // builds the size cards + may clear an unavailable saved size
      if (state.size) {
        var sizeInput = section.querySelector('[data-byb-size][value="' + state.size + '"]');
        if (sizeInput && !sizeInput.disabled) sizeInput.checked = true;
      }
      if (state.customize) {
        var custInput = section.querySelector('[data-byb-customize][value="' + state.customize + '"]');
        if (custInput) custInput.checked = true;
      }
      renderActivities();
      showStep(state.step || 1);
    }

    rehydrate();
  })();

  } catch(e) { console.error(e); }
})();
})();
